import { tabelaPrecoService } from '@/services/tabelaPrecoService';

const getDefaultState = () => {
  return {
    tabelasPreco: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  tabelasPreco: state => state.tabelasPreco,
  isTabelasPrecoModified: state => !!state.isModified
};

const actions = {
  async fetchTabelasPreco({ commit }) {
    try {
      const response = await tabelaPrecoService.getTabelasPreco();
      commit('SET_TABELAS_PRECO', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchTabelasPrecoAPI({ commit }) {
    try {
      const response = await tabelaPrecoService.getTabelasPrecoAPI();
      commit('SET_TABELAS_PRECO', response);
      commit('SET_IS_TABELAS_PRECO_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
};

const mutations = {
  CLEAR_TABELAS_PRECO_STATE: state => Object.assign(state, getDefaultState()),
  SET_TABELAS_PRECO: (state, tabelasPreco) => state.tabelasPreco = tabelasPreco,
  SET_IS_TABELAS_PRECO_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}